import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod/v4";

import data from "../../assets/mocks/watchlists.json";
import { getWatchlistsQueryOptions } from "./get-watchlists";

import { api } from "@/lib/api-client";
import { AxiosMock } from "@/utils/mock";

import type { MutationConfig } from "@/lib/react-query";
import type { Watchlist } from "@/types/watchlist";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for watchlists
  const mock = AxiosMock.getInstance();
  mock.onPost(`/carburate/watchlists/`).reply(201, data[1]); // Assuming the first item in data is the new watchlist
}

export const createWatchlistInputSchema = z.object({
  name: z.string().nonempty(),
});

export type CreateWatchlistInput = z.infer<typeof createWatchlistInputSchema>;

export const createWatchlist = ({ data }: { data: CreateWatchlistInput }) => {
  return api.post("/carburate/watchlists/", data) as Promise<Watchlist>;
};

type UseCreateWatchlistOptions = {
  mutationConfig?: MutationConfig<typeof createWatchlist>;
};

export const useCreateWatchlist = ({ mutationConfig }: UseCreateWatchlistOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: getWatchlistsQueryOptions().queryKey });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: createWatchlist,
  });
};
